import { useContext } from 'react';
import InitContext from '../context/initContext';

/**
 * useInitContext is a convenience hook to access the init context
 */
export default function useInitContext() {
  return useContext(InitContext);
}
